import toast from "react-hot-toast";
import surveyInstance, { surveyUATInstance } from "..";
import axios from "axios";

const { get, post } = surveyInstance;

const smsBaseURL = process.env.REACT_APP_SMS_BASE_URL;

const validateSurveyCode = async (survey_code) => {
	const response = get(`/survey/code?survey_code=${survey_code}`);
	return (await response).data;
};

const validateLongSurveyCode = async (payload) => {
	const response = surveyUATInstance.get(
		`/survey/code?survey_code=${payload?.survey_code}&survey_id=${payload?.survey_id}`,
	);
	return (await response).data;
};

const getSurveyById = async (survey_id) => {
	const response = await get(`/survey/new/${survey_id}`);
	return response.data;
};

const getSurveySections = async (survey_id) => {
	const response = await surveyUATInstance.get(
		`/survey/new/section/survey_id/${survey_id}`,
	);
	return response.data;
};

const getSurveySectionById = async (section_id) => {
	const response = await surveyUATInstance.get(
		`/survey/new/section/section_id/${section_id}`,
	);
	return response.data;
};

const getSectionQuestions = async (sectionId) => {
	const response = await surveyUATInstance.get(
		`/survey/new/quiz/section_id${sectionId}`,
	);
	return response.data;
};

const initiateSurveySection = async (
	survey_code,
	phone_number,
	survey_id,
	section_id,
) => {
	const response = surveyUATInstance.get(
		`/survey/section?survey_code=${survey_code}&survey_id=${survey_id}&phone_number=${encodeURIComponent(
			phone_number,
		)}&section_id=${section_id}`,
	);
	return (await response).data;
};

const submitSurvey = async (payload) => {
	const response = post("/survey", payload);
	return (await response).data;
};

const submitUATSurvey = async (payload) => {
	try {
		const response = surveyUATInstance.post("/survey", payload);
		return (await response).data;
	} catch (error) {
		console.log(error);
		toast.error(error?.response?.data?.message ?? "Bad request....");
	}
};

const sendAishaSms = async (payload) => {
	const response = await axios.post(
		`${smsBaseURL}/contact-management/sms`,
		payload,
	);
	return response.data;
};

const generateSurveyCode = async (payload) => {
	const response = surveyUATInstance.post(`/survey/get-code`, payload);
	return (await response).data;
};

const getSurveyCode = async (phoneNumber) => {
	const response = await surveyUATInstance.get(`/survey_code/${phoneNumber}`);
	return response.data;
};

export {
	validateSurveyCode,
	validateLongSurveyCode,
	initiateSurveySection,
	submitSurvey,
	submitUATSurvey,
	getSurveyById,
	getSurveySections,
	getSectionQuestions,
	getSurveySectionById,
	sendAishaSms,
	generateSurveyCode,
	getSurveyCode,
};
